import { modelOptions, prop } from '@typegoose/typegoose';
import * as mongoose from 'mongoose';
import {LearningStateModel} from './learning.state';
import {RecommendationsModel} from './recommendations.model';
import {CategoryStateModel} from './category.state.model';

// should be moved to a shared library
enum PhasrCategory {
  TAMPERING_TOOL = 1,
  HACKTOOL = 2,
  REMOTE_TOOL = 3,
  MINER = 4,
  LOLBIN = 5,
}

@modelOptions({ schemaOptions: { collection: 'companyAttackSurfaceSpecificAggregationState' }, options: { customName: 'companyAttackSurfaceSpecificAggregationState' } })
export class CategoriesModel {
  @prop({ required: true,  _id: true })
  _id: mongoose.Types.ObjectId;

  @prop({ required: true , enum: PhasrCategory, type: mongoose.Schema.Types.Number })
  category: PhasrCategory;

  @prop({ required: true, type: LearningStateModel })
  learningState: LearningStateModel;

  @prop({ required: false, type: CategoryStateModel })
  categoryState: CategoryStateModel;

  @prop({ required: false, type: [RecommendationsModel] })
  recommendations: Array<RecommendationsModel>;
}
